<p-inputgroup class="mb-3 input-group-ai-suggest">
  <p-inputgroup-addon>
    <i
      class="ri-sparkling-fill text-primary"
      style="font-size: 20px"
    ></i>
  </p-inputgroup-addon>
  <ng-content #name></ng-content>
  <p-button
    severity="primary"
    size="small"
    icon="ri-sparkling-line"
    [loading]="this.isSuggestingName"
    [disabled]="this.isSuggestingName"
    (onClick)="this.suggestName()"
    i18n-label="@@ai-suggestion"
    label="KI-Vorschlag"
  ></p-button>
</p-inputgroup>